var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropDown',{attrs:{"label":_vm.control.label,"name":_vm.control.label,"optionLabelKey":"text","options":_vm.getDisplayOptions(_vm.control),"optionValueKey":"value","tooltip":_vm.getTooltip(),"value":_vm.handleDisplayValue(_vm.control)},on:{"input":_vm.handleChangeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }